export default "__VITE_ASSET__5wLm5N6r__"